/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */
const HRISandVSMS = r => require.ensure([], () => r(require('./components/HRISandVSMS')), 'HRISandVSMS');
const HRISandVSMSlogs = r => require.ensure([], () => r(require('./components/HRISandVSMSlogs')), 'HRISandVSMS');
const HRISandVSMsingleLogs = r => require.ensure([], () => r(require('./components/HRISandVSMsingleLogs')), 'HRISandVSMS');

export default [
    
    {
        name: 'HRISandVSMS',
        path: '/setting/HRIS-VSMS',
        component: HRISandVSMS,
    },
    {
        name: 'HRISandVSMSlogs',
        path: '/setting/HRIS-VSMS-logs',
        component: HRISandVSMSlogs,
    },
    {
        name: 'HRISandVSMsingleLogs',
        path: '/setting/HRIS-VSMS-logs/:id',
        component: HRISandVSMsingleLogs,
    },

    
]



// WEBPACK FOOTER //
// ./src/app/HRISandVSMS/routes.js